import React, { useContext, useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import Breadcrumbs, { BreadcrumbsItem } from '../../../template/MainTheme/components/Breadcrumbs';
import DefaultCard from '../../../components/default/DefaultCard';

import { toast } from 'react-toastify';
import { AppContext } from '../../../contexts/AppContext';
import UserForm from '../../Users/components/forms/UserForm';
import { UserDataForm, defaultUserDataForm } from '../../../app/models/User';
import LazyLoading from '../../../components/LazyLoading';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import useAuthService from '../../../app/services/hooks/useAuthService';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';

const breadcrumbs: BreadcrumbsItem[] = [
    {
        name: 'Perfil',
        url: '/intranet/edit-profile',
        isActive: true
    }
];

const Profile = () => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const [profile, setProfile] = useState<UserDataForm>(defaultUserDataForm);
    const { getProfile, fetchingGetProfile, updateProfile, fetchingUpdateProfile } =
        useAuthService();
    const [errorFields, setErrorFields] = useState<Record<string, string[]>>({});

    useEffect(() => {
        userProfile();
    }, []);

    const userProfile = () => {
        if (showLoading) showLoading('loading', 'Cargando perfil');
        getProfile({
            onSuccess: (response: ServiceResponse) => {
                const _user = response.data.profile;

                _user.roles = (response.data.profile.groups || []).map((group: { id: number; name: string }) => ({
                    id: group.id,
                    name: group.name
                }));

                setProfile(_user);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message, {
                    autoClose: 2000
                });
            }
        });
    };

    const updateUserProfile = () => {
        if (showLoading) showLoading('loading', 'Actualizando perfil');
        updateProfile(profile, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields({});
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
                toast.error('Por favor corrige los errores en el formulario');
            }
        });
    };

    return fetchingGetProfile ? (
        <LazyLoading height="300" />
    ) : (
        <>
            <Breadcrumbs pageSection="Perfil de usuario" breadcrumbs={breadcrumbs} />
            <div className="row">
                <div className="col-12">
                    <DefaultCard>
                        <UserForm
                            userForm={profile}
                            setUserForm={setProfile}
                            isProfile={true}
                            errorFields={errorFields}
                        />
                        <hr />
                        <div className="row justify-content-end">
                            <div className="col-auto">
                                <ButtonSaveForm
                                    callbackSave={updateUserProfile}
                                    locked={fetchingUpdateProfile}
                                />
                            </div>
                        </div>
                    </DefaultCard>
                </div>
            </div>
        </>
    );
};

export default Profile;
